import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {ActivatedRoute, NavigationEnd, Params, Router} from '@angular/router';
import { ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { Subscription } from 'rxjs';
import { Company } from 'src/app/model/company';
import { PageNumbers, ReportState } from 'src/app/model/Enums';
import { Report } from 'src/app/model/report';
import { ReportProvider } from 'src/app/providers';
import { ReportService, SocketService, ToasterService, UserService } from 'src/app/services';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('open', style({ right: '0px' })),
      state('closed', style({ right: '-300px' })),
      transition('open <=> closed', [animate('300ms ease-in-out')]),
    ]),
    trigger('moveButton', [
      state('open', style({ right: '299px' })), // Move button when panel opens
      state('closed', style({ right: '0px' })), // Reset button position
      transition('open <=> closed', [animate('300ms ease-in-out')]),
    ]),
  ],
})
export class ReportComponent implements OnInit, OnDestroy {

  public currentReport: Report;
  private reportSub: Subscription;
  // private stompSubscription: any = null;

  reportId: string = '';
  versionId: string = '';
  firstTitle: string = '';
  secondTitle: string = '';
  infoTooltip: string = '';

  stageNo: number = 0;
  url_list: string[] = [];

  pageNumberEnum = PageNumbers;
  reportStateEnum = ReportState;
  showNotification: boolean = true;
  isSideMenuOpen: boolean = false;

  @ViewChild('reportPart') reportPart: ElementRef;

  constructor(
    private router: Router,
    private reportService: ReportService,
    private reportProvider: ReportProvider,
    private socketService: SocketService,
    private toastr: ToasterService,
    private scrollToService: ScrollToService,
    public userService: UserService,
    protected route: ActivatedRoute
  ) {

    this.route.params.subscribe((params: Params) => {
      if (params.id) {
        this.reportId = params.id;
        if (this.route.snapshot['_routerState'].url.startsWith('/report')) {
          this.updateReportData(this.route.snapshot['_routerState'].url);
        }
      }
    });

    this.router.events.subscribe((data: any) => {
      // If routing successful
      if (data instanceof NavigationEnd) {
        if (data.url && data.url.startsWith('/report')) {
          this.updateReportData(data.url);
        }
      }
    });
  }

  ngOnInit(): void {
    if (this.reportId) {
      this.getSingleReportDetails();
    } else {
      this.router.navigateByUrl('/dashboard');
    }
  }

  ngOnDestroy(): void {
    this.socketService.unsubscribeFromReport();
    this.reportService.clearReport();
  }

  updateReportData(fullUrl: string): void {
    const urlWithoutQueryParam = fullUrl.split('?')[0];
    const url = fullUrl.substr(fullUrl.lastIndexOf('/'), fullUrl.length);
    if (url != '/required-information') {
      this.url_list = urlWithoutQueryParam.split('/').filter(itm => itm);
      this.getCurrntStage(this.url_list[this.url_list.length - 1]);
      if (document.getElementById('reportPart')) {
        document.getElementById('reportPart').scrollTo(0, 0);
      }
    }
  }

  getCurrntStage(routeUrl: string) {
    this.firstTitle = '';
    this.secondTitle = '';
    this.infoTooltip = '';
    switch (routeUrl) {
      /* case 'entity-reference':
        this.stageNo = PageNumbers.ENTITY_REFERENCE;
        break;
      case 'industry-name':
        this.stageNo = PageNumbers.INDUSTRY_NAME;
        break;
      case 'seller-business':
        this.stageNo = PageNumbers.SELLER_BUSINESS;
        break;
      case 'company-dba':
        this.stageNo = PageNumbers.COMPANY_DBA;
        break;
      case 'business-entity':
        this.stageNo = PageNumbers.BUSINESS_ENTITY;
        break;
      case 'franchise':
        this.stageNo = PageNumbers.FRANCHISE;
        break;
      case 'transaction-type':
        this.stageNo = PageNumbers.TRANSACTION_TYPE;
        break; */
      case 'overview':
        this.stageNo = PageNumbers.OVERVIEW;
        break;
      /* case 'covid-impact':
        this.stageNo = PageNumbers.COVID_IMPACT
        break;
      case 'service-type':
        this.stageNo = PageNumbers.SERVICE_TYPE
        break;
      case 'closures-restrictions':
        this.stageNo = PageNumbers.CLOSURES_RESTRICTIONS
        break;
      case 'additional-debt':
        this.stageNo = PageNumbers.ADDITIONAL_DEBT
        break; */
      case 'special-consideration':
        this.stageNo = PageNumbers.SPECIAL_CONSIDERATION;
        break;
      /* case 'location-amount':
        this.stageNo = PageNumbers.LOCATION_AMOUNT;
        break;
      case 'location-details':
        this.stageNo = PageNumbers.LOCATION_DETAILS;
        break; */
      case 'location':
        this.stageNo = PageNumbers.LOCATION;
        break;
      /* case 'owner-amount':
        this.stageNo = PageNumbers.OWNER_AMOUNT;
        break;
      case 'owner-details':
        this.stageNo = PageNumbers.OWNER_DETAILS;
        break; */
      case 'ownership':
        this.stageNo = PageNumbers.OWNERSHIP;
        break;
      /* case 'year-end':
        this.stageNo = PageNumbers.YEAR_END;
        break;
      case 'recent-financials':
        this.stageNo = PageNumbers.RECENT_FINANCIALS;
        break;
      case 'income-table':
        this.stageNo = PageNumbers.INCOME_TABLE;
        break;
      case 'future-year':
        this.stageNo = PageNumbers.FUTURE_YEAR;
        break; */
      case 'income':
        this.stageNo = PageNumbers.INCOME;
        break;
      case 'future-projection':
        this.stageNo = PageNumbers.FUTURE_PROJECTIONS;
        break;
      case 'rent-details':
        this.stageNo = PageNumbers.RENT_DETAILS;
        break;
      case 'manager-salary':
        this.stageNo = PageNumbers.MANAGER_SALARY;
        break;
      case 'replacement-salary':
        this.stageNo = PageNumbers.REPLACEMENT_SALARY;
        break;
      case 'adjustments':
        this.stageNo = PageNumbers.ADJUSTMENTS;
        break;
      // case 'future-prediction':
      //   this.stageNo = PageNumbers.FUTURE_PREDICTION
      //   break;
      case 'weighting-table':
        this.stageNo = PageNumbers.WEIGHTING_TABLE;
        break;
      case 'projection-table':
        this.stageNo = PageNumbers.PROJECTION_TABLE;
        break;
      /* case 'purchase-price':
        this.stageNo = PageNumbers.PURCHASE_PRICE;
        break;
      case 'assets':
        this.stageNo = PageNumbers.ASSETS;
        break;
      case 'liabilities':
        this.stageNo = PageNumbers.LIABILITIES;
        break; */
      case 'assets-liabilities':
        this.stageNo = PageNumbers.ASSETS_LIABILITIES;
        break;

      /* case 'customers-amount':
        this.stageNo = PageNumbers.CUSTOMERS_AMOUNT;
        break;
      case 'div15-annual-revenue':
        this.stageNo = PageNumbers.DIV15_ANNUAL_REVENUE;
        break;
      case 'div50-annual-revenue':
        this.stageNo = PageNumbers.DIV50_ANNUAL_REVENUE;
        break;
      case 'notable-supplier':
        this.stageNo = PageNumbers.NOTABLE_SUPPLIER;
        break; */
      case 'diversification':
        this.stageNo = PageNumbers.DIVERSIFICATION;
        break;
      case 'personal-goodwill':
        this.stageNo = PageNumbers.PERSONAL_GOODWILL;
        break;
      case 'barriers-entry':
        this.stageNo = PageNumbers.BARRIERS_ENTRY;
        break;
      case 'recurring-revenue':
        this.stageNo = PageNumbers.RECURRING_REVENUE;
        break;
      case 'conclusion':
        this.stageNo = PageNumbers.CONCLUSION;
        break;
      case 'pricing':
      case 'billing':
      case 'card-info':
      case 'success':
        this.stageNo = 50;
        break;
      default:
        this.stageNo = null;
        break;
    }
    switch (this.stageNo) {
      // case PageNumbers.ENTITY_REFERENCE:
      // case PageNumbers.INDUSTRY_NAME:
      // case PageNumbers.SELLER_BUSINESS:
      // case PageNumbers.COMPANY_DBA:
      // case PageNumbers.BUSINESS_ENTITY:
      // case PageNumbers.FRANCHISE:
      // case PageNumbers.TRANSACTION_TYPE:
      case PageNumbers.OVERVIEW:
        this.firstTitle = 'Company Information';
        this.secondTitle = 'Overview';
        break;
      // case PageNumbers.COVID_IMPACT:
      // case PageNumbers.SERVICE_TYPE:
      // case PageNumbers.CLOSURES_RESTRICTIONS:
      // case PageNumbers.ADDITIONAL_DEBT:
      case PageNumbers.SPECIAL_CONSIDERATION:
        this.firstTitle = 'Company Information';
        this.secondTitle = 'Special Consideration';
        break;
      // case PageNumbers.LOCATION_AMOUNT:
      // case PageNumbers.LOCATION_DETAILS:
      case PageNumbers.LOCATION:
        this.firstTitle = 'Company Information';
        this.secondTitle = 'Location';
        break;
      // case PageNumbers.OWNER_AMOUNT:
      // case PageNumbers.OWNER_DETAILS:
      case PageNumbers.OWNERSHIP:
        this.firstTitle = 'Company Information';
        this.secondTitle = 'Ownership';
        break;
      // case PageNumbers.YEAR_END:
      // case PageNumbers.RECENT_FINANCIALS:
      // case PageNumbers.FUTURE_YEAR:
      //   this.firstTitle = 'Financials';
      //   this.secondTitle = 'Income';
      //   break;
      // case PageNumbers.INCOME_TABLE:
      //   this.firstTitle = 'Financials';
      //   this.secondTitle = 'Income';
      //   this.infoTooltip = 'Non-recurring income or expenses, discretionary and non-business expenses, can be entered later in the "Adjustments" tab';
      //   break;
      case PageNumbers.INCOME:
        this.firstTitle = 'Financials';
        this.secondTitle = 'Income';
        break;
      case PageNumbers.FUTURE_PROJECTIONS:
        this.firstTitle = 'Financials';
        this.secondTitle = 'Future Projections';
        break;
      case PageNumbers.RENT_DETAILS:
        this.firstTitle = 'Financials';
        this.secondTitle = 'Rent';
        break;
      case PageNumbers.MANAGER_SALARY:
        this.firstTitle = 'Financials';
        this.secondTitle = 'Owner’s Salary';
        this.infoTooltip = 'Because the Current Ownership works 15 or less hours a week combined, the business is deemed to be operated passively (Absentee/Semi Absentee). Therefore, a fair market replacement salary must be adjusted for.';
        break;
      case PageNumbers.REPLACEMENT_SALARY:
        this.firstTitle = 'Financials';
        this.secondTitle = 'Owner’s Salary';
        break;
      case PageNumbers.ADJUSTMENTS:
        this.firstTitle = 'Financials';
        this.secondTitle = 'Adjustments';
        this.infoTooltip = 'Examples would include discretionary owner(s)’s expenses, non-recurring expenses, bad debt, health insurance, and net gains or losses.';
        break;
      // case PageNumbers.FUTURE_PREDICTION:
      //   this.firstTitle = 'Financials';
      //   this.secondTitle = 'Weighting';
      //   this.infoTooltip = 'The system will base the projected SDE based on the company’s last fiscal year’s perfomance. You can manually change the margin if necessary';
      //   break;
      case PageNumbers.WEIGHTING_TABLE:
        this.firstTitle = 'Financials';
        this.secondTitle = 'Summary';
        break;
      case PageNumbers.PROJECTION_TABLE:
        this.firstTitle = 'Financials';
        this.secondTitle = 'Projections';
        break;
      /* case PageNumbers.PURCHASE_PRICE:
        this.firstTitle = 'Financials';
        this.secondTitle = 'Assets / Liabilities';
        break;
      case PageNumbers.ASSETS:
        this.firstTitle = 'Financials';
        this.secondTitle = 'Assets';
        this.infoTooltip = 'Do not include intangible assets such as goodwill, licenses, non-compete, etc.';
        break;
      case PageNumbers.LIABILITIES:
        this.firstTitle = 'Financials';
        this.secondTitle = 'Liabilities';
        this.infoTooltip = 'Do not include intangible assets such as goodwill, licenses, non-compete, etc.';
        break; */
      case PageNumbers.ASSETS_LIABILITIES:
        this.firstTitle = 'Financials';
        this.secondTitle = 'Assets / Liabilities';
        break;
      // case PageNumbers.CUSTOMERS_AMOUNT:
      // case PageNumbers.DIV15_ANNUAL_REVENUE:
      // case PageNumbers.DIV50_ANNUAL_REVENUE:
      // case PageNumbers.NOTABLE_SUPPLIER:
      case PageNumbers.DIVERSIFICATION:
        this.firstTitle = 'Risk';
        this.secondTitle = 'Diversification / Concentration';
        break;
      case PageNumbers.PERSONAL_GOODWILL:
        this.firstTitle = 'Risk';
        this.secondTitle = 'Personal Goodwill';
        break;
      case PageNumbers.BARRIERS_ENTRY:
        this.firstTitle = 'Risk';
        this.secondTitle = 'Barriers to Entry';
        break;
      case PageNumbers.RECURRING_REVENUE:
        this.firstTitle = 'Risk';
        this.secondTitle = 'Recurring Revenue';
        break;
      case PageNumbers.CONCLUSION:
        this.firstTitle = 'Final Value';
        this.secondTitle = '';
        break;
      default:
        this.firstTitle = '';
        this.secondTitle = '';
        break;
    }

  }

  getSingleReportDetails() {
    this.reportProvider.getReportDetails(this.reportId).subscribe(res => {
      if (res.success) {
        this.currentReport = Report.parse(res.result);
        this.reportService.setReport(this.currentReport);

        if (!this.currentReport.LATEST.COMPANY) {
          this.createCompany();
        }

        if (this.currentReport != null) {
          this.socketService.unsubscribeFromReport();
          this.socketService.subscribeToReport(this.currentReport.LATEST.ID);
        }
        if (this.url_list.length < 3)
          this.gotoLastUpdatedPage(this.currentReport.LATEST.MAX_STAGE);
      } else {
        if (res.error.code == 400) {
          this.toastr.warning(res.error.txt);
          this.router.navigateByUrl(`/dashboard`);
        } else {
          this.toastr.error(res.error.txt);
        }
      }
    }, err => {
      // Error Handling
    });
  }

  createCompany() {
    this.reportProvider.saveCompanyDetails(this.currentReport.LATEST.ID, new Company()).subscribe(res => {
      if (res.success) {
        this.currentReport.LATEST.COMPANY = res.result;
      }
    });
  }

  gotoLastUpdatedPage(lastStage: number) {
    // comment for alternative flow
    // let pageLink = 'overview/entity-reference';
    let pageLink = 'overview';
    switch (lastStage) {
      /* case PageNumbers.ENTITY_REFERENCE:
        pageLink = 'overview/entity-reference';
        break;
      case PageNumbers.INDUSTRY_NAME:
        pageLink = 'overview/industry-name';
        break;
      case PageNumbers.SELLER_BUSINESS:
        pageLink = 'overview/seller-business';
        break;
      case PageNumbers.COMPANY_DBA:
        pageLink = 'overview/company-dba';
        break;
      case PageNumbers.BUSINESS_ENTITY:
        pageLink = 'overview/business-entity';
        break;
      case PageNumbers.FRANCHISE:
        pageLink = 'overview/franchise';
        break;
      case PageNumbers.TRANSACTION_TYPE:
        pageLink = 'overview/transaction-type';
        break; */
      case PageNumbers.OVERVIEW:
        pageLink = 'overview';
        break;
      /* case PageNumbers.COVID_IMPACT:
        pageLink = 'special-consideration/covid-impact';
        break;
      case PageNumbers.SERVICE_TYPE:
        pageLink = 'special-consideration/service-type';
        break;
      case PageNumbers.CLOSURES_RESTRICTIONS:
        pageLink = 'special-consideration/closures-restrictions';
        break;
      case PageNumbers.ADDITIONAL_DEBT:
        pageLink = 'special-consideration/additional-debt';
        break; */
      case PageNumbers.SPECIAL_CONSIDERATION:
        pageLink = 'special-consideration';
        break;
      /* case PageNumbers.LOCATION_AMOUNT:
        pageLink = 'location/location-amount';
        break;
      case PageNumbers.LOCATION_DETAILS:
        pageLink = 'location/location-details';
        break; */
      case PageNumbers.LOCATION:
        pageLink = 'location';
        break;
      /* case PageNumbers.OWNER_AMOUNT:
        pageLink = 'owner/owner-amount';
        break;
      case PageNumbers.OWNER_DETAILS:
        pageLink = 'owner/owner-details';
        break; */
      case PageNumbers.OWNERSHIP:
        pageLink = 'ownership';
        break;
      /* case PageNumbers.YEAR_END:
        pageLink = 'income/year-end';
        break;
      case PageNumbers.RECENT_FINANCIALS:
        pageLink = 'income/recent-financials';
        break;
      case PageNumbers.INCOME_TABLE:
        pageLink = 'income/income-table';
        break;
      case PageNumbers.FUTURE_YEAR:
        pageLink = 'income/future-year';
        break; */
      case PageNumbers.INCOME:
        pageLink = 'income';
        break;
      case PageNumbers.FUTURE_PROJECTIONS:
        pageLink = 'future-projection';
        break;
      case PageNumbers.RENT_DETAILS:
        pageLink = 'rent/rent-details';
        break;
      case PageNumbers.MANAGER_SALARY:
        pageLink = 'salary/manager-salary';
        break;
      case PageNumbers.REPLACEMENT_SALARY:
        pageLink = 'salary/replacement-salary';
        break;
      case PageNumbers.ADJUSTMENTS:
        pageLink = 'adjustments';
        break;
      // case PageNumbers.FUTURE_PREDICTION:
      //   pageLink = 'weighting/future-prediction';
      //   break;
      case PageNumbers.WEIGHTING_TABLE:
        pageLink = 'weighting/weighting-table';
        break;
      case PageNumbers.PROJECTION_TABLE:
        pageLink = 'projections/projection-table';
        break;
      /* case PageNumbers.PURCHASE_PRICE:
        pageLink = 'assetsLiabilities/purchase-price';
        break;
      case PageNumbers.ASSETS:
        pageLink = 'assetsLiabilities/assets';
        break;
      case PageNumbers.LIABILITIES:
        pageLink = 'assetsLiabilities/liabilities';
        break; */
      case PageNumbers.ASSETS_LIABILITIES:
        pageLink = 'assets-liabilities';
        break;

      /* case PageNumbers.CUSTOMERS_AMOUNT:
        pageLink = 'risk/customers-amount';
        break;
      case PageNumbers.DIV15_ANNUAL_REVENUE:
        pageLink = 'risk/div15-annual-revenue';
        break;
      case PageNumbers.DIV50_ANNUAL_REVENUE:
        pageLink = 'risk/div50-annual-revenue';
        break;
      case PageNumbers.NOTABLE_SUPPLIER:
        pageLink = 'risk/notable-supplier';
        break; */
      case PageNumbers.DIVERSIFICATION:
        pageLink = 'risk/diversification';
        break;
      case PageNumbers.PERSONAL_GOODWILL:
        pageLink = 'risk/personal-goodwill';
        break;
      case PageNumbers.BARRIERS_ENTRY:
        pageLink = 'risk/barriers-entry';
        break;
      case PageNumbers.RECURRING_REVENUE:
        pageLink = 'risk/recurring-revenue';
        break;
      case PageNumbers.CONCLUSION:
        pageLink = 'conclusion';
        break;
      default:
        pageLink = 'overview';
        break;
    }

    // for if user set all rent questions No - NO
    if (lastStage == PageNumbers.RENT_DETAILS && !this.reportService.showRentAdjustments()) {
      pageLink = 'future-projection';
    }

    // else if (lastStage == PageNumbers.MANAGER_SALARY && this.reportService.showOwnershipSalary() == 1) {

    // } else if (lastStage == PageNumbers.REPLACEMENT_SALARY && this.reportService.showOwnershipSalary() == 2) {

    // }
    this.router.navigateByUrl(`/report/${this.currentReport.ID}/${pageLink}`);
  }

  closeNotification(): void {
    this.showNotification = false;
  }

  gotoConclusion() {
    this.router.navigateByUrl(`/report/${this.currentReport.ID}/conclusion`);
  }

  @HostListener('window:keyup', ['$event'])
  onKeyUp($event: KeyboardEvent) {
    if ($event.keyCode == 9) {
      document.activeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    }
  }

  toggleReportMenu(): void{
    this.isSideMenuOpen = !this.isSideMenuOpen;
  }
}
